import React from 'react'
import "./index.scss"
export const ButtonApp = ({title , handlClick}) => {
  return (
   <button onClick={handlClick } className='btn-app' >{title}</button>
  )
}
